import React from 'react'

let Pastinfo = {
    "year":[2020,2021,2022]
}

export default Pastinfo;